
import { granjaApi } from "../../api";







export const loginService = async (login) => {
    try {
        const { data } = await granjaApi.post('/usuario', login );
        return data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        throw new Error(errores);
    }
}




export const checkStatus = async () => {
    try {
        const { data } = await granjaApi.get('/usuario/renew');
        return data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        throw new Error(errores);
    }
}



    // static actualizarPassword = async (valor:any): Promise<any> => {
    //     try {
    //         const { data } = await authApi.put<any>('/update/password', valor);
    //         return data;
    //     } catch (error: any) {
    //         const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
    //         throw new Error(errores);
    //     }
    // }





    // static resetPassword = async (id:string): Promise<any> => {
    //     try {
    //         const { data } = await authApi.put<any>(`/reset/password/${id}`);
    //         return data.data;
    //     } catch (error: any) {
    //         const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
    //         Swal.fire('Error', errores, 'error');
    //         throw new Error(errores);
    //     }
    // }